import { FC } from 'react';

import { ActionBar, BottomSheet, Button, Modal, NavBar, Text } from '@hh.ru/magritte-ui';
import { CrossOutlinedSize24 } from '@hh.ru/magritte-ui/icon';

import useTrls from 'hooks/translation/useTrls';

import { deleteUserLoadedImage } from 'components/common/BannerImg/GalleryModal/Image/WarningModal/deleteUserLoadedImage';
import { MagritteModalHeader } from 'components/common/MagritteModalHeader/MagritteModalHeader';

import { useDispatch } from 'store/utils';

interface WarningModalProps {
    visible: boolean;
    onClose: () => void;
    id: number;
}

const TrlKeys = {
    title: 'AdCreate.AdForm.BannerImg.ModalGallery.Image.delete.question',
    text: 'AdCreate.AdForm.BannerImg.ModalGallery.Image.delete.warning',
    cancel: 'AdCreate.AdForm.BannerImg.ModalGallery.Image.ModalWarning.cancel',
    delete: 'AdCreate.AdForm.BannerImg.ModalGallery.Image.ModalWarning.delete',
};

export const WarningModal: FC<WarningModalProps> = ({ visible, onClose, id }) => {
    const dispatch = useDispatch();
    const trls = useTrls();

    const footer = (
        <ActionBar
            primaryActions={
                <>
                    <Button stretched onClick={onClose} mode="secondary" style="accent">
                        {trls(TrlKeys.cancel)}
                    </Button>
                    <Button
                        stretched
                        mode="primary"
                        style="accent"
                        onClick={() => {
                            dispatch(deleteUserLoadedImage(id));
                            onClose();
                        }}
                    >
                        {trls(TrlKeys.delete)}
                    </Button>
                </>
            }
        />
    );

    const content = <Text>{trls(TrlKeys.text)}</Text>;

    return (
        <>
            <Modal
                visible={visible}
                onClose={onClose}
                size="small"
                header={
                    <MagritteModalHeader
                        title={trls(TrlKeys.title)}
                        actions={<CrossOutlinedSize24 initialColor="secondary" onClick={onClose} />}
                    />
                }
                footer={footer}
            >
                {content}
            </Modal>
            <BottomSheet
                visible={visible}
                onClose={onClose}
                footer={footer}
                header={
                    <NavBar>
                        <NavBar.Pane>
                            <NavBar.Stage>
                                <NavBar.Actions left centered right={<CrossOutlinedSize24 onClick={onClose} />}>
                                    <NavBar.TitleContainer
                                        title={<Text typography="subtitle-1-semibold">{trls(TrlKeys.title)}</Text>}
                                    />
                                </NavBar.Actions>
                            </NavBar.Stage>
                        </NavBar.Pane>
                    </NavBar>
                }
            >
                {content}
            </BottomSheet>
        </>
    );
};
